import {fetch} from 'wix-fetch';
import wixData from 'wix-data';
import {fetchData, fetchByDate, getStockDataFromApi, get52WeekHighLow} from 'backend/fetchData.jsw';
import {getChange, getTickerLastUpdatedText} from 'public/tickerFunctions';
import {dateFormat} from 'public/pressReleasesFunctions';

$w.onReady(async function () {
	Promise.all([get52WeekHighLow(), getStockDataFromApi()]).then((values => {
		populateStockTable({...values[0], ...values[1]});
	}));
	

	function populateStockTable(results) {
		let color = (results.rawChangePrice > 0) ? '#64B743' : '#C60000';
		let posNegPrefix = ( results.rawChangePrice > 0 ) ? '+' : '-';

		$w('#tickerText').text = getTickerLastUpdatedText(results.marketTime);
		$w('#tickerText').show();
		
		let stockInfo = {
			todaysOpen: `$${results.formattedOpenPrice}`,
			intradayHigh: `$${results.formattedIntraDayHigh}`,
			intradayLow: `$${results.formattedIntraDayLow}`,
			currentPrice: `$${results.formattedStockPrice}`,
			volume: results.formattedVolume,
			previousClose: `$${results.formattedPreviousClose}`,
			changePrice: `$${results.formattedChangePrice}`,
			changePercentage: `${results.formattedChangePercentage}`,
			pastYearHigh:  `${results.yearlyHigh}`,
			pastYearLow:  `${results.yearlyLow}`
		}

		Object.entries(stockInfo).forEach(([key, value]) => {
			if( key === 'changePercentage' || key === 'changePrice' ) {
				$w('#'+key).html = '<span style="font-size: 16px; color:' + color + '">' + posNegPrefix + value + '</span>'
			}else{
				$w('#'+key.toString()).text = value;
			}
			$w('#'+key).expand();
		});
	}

	function setFilter(){
		let today = new Date();
		let mm = today.getMonth();
		let dd = today.getDate();
		let yyyy = today.getFullYear();
		$w('#filterMonth').selectedIndex = mm;
		$w('#filterYear').selectedIndex = 0;
		filtersChange(dd-1);
	}
	setFilter();
});

function daysInMonth (month, year) {
	let number = new Date(year, month, 0).getDate();
	let opts = $w('#filterDay').options;
	for (let i = 1; i <= number; i++) {
		let prefix = ( i < 10 ) ? 0: '';
		opts.push({'label': prefix+i.toString(), 'value': prefix+i.toString()});
	}
	$w('#filterDay').options = opts;
}

async function filtersChange(selectedDay) {
	let month = $w('#filterMonth').value;
	let year = $w('#filterYear').value;	
	daysInMonth(month, year);

	if( selectedDay ) {
		$w('#filterDay').selectedIndex = selectedDay;
	}

	let day = $w('#filterDay').value;
	
	if( day && month && year) {
		let date = year+'-'+month+'-'+day;
		await fetchByDate(date).then( item => {
					let result = item['Time Series (Daily)'][date];
					if( !item || result === undefined) {
						$w('#messageNoResults').show();
						$w('#filterFieldsGroup').hide();
					}else{
						updateFilterData(result, date);
						$w('#messageNoResults').hide();
						$w('#filterFieldsGroup').show();
					}
				}).catch( (err) => {
				let errorMsg = err;
			} );
	}
}

function updateFilterData(result, date) {
	let filterDate = date;
	let filterOpen = '$'+Number(result['1. open']).toFixed(2);
	let filterDaysHigh = '$'+Number(result['2. high']).toFixed(2);
	let filterDaysLow = '$'+Number(result['3. low']).toFixed(2);
	let filterClose = '$'+Number(result['4. close']).toFixed(2);
	let filterVolume = parseInt(result['6. volume']).toLocaleString();
	let rawDate = date.split("-");
	let rawDateFormat = rawDate[0]+"/"+rawDate[1]+"/"+rawDate[2];
	let timestamp = new Date(rawDateFormat).getTime();
	let dateToFormat = dateFormat(timestamp / 1000);
	$w('#filterDate').text = dateToFormat;

	let dataObj = {
		filterDate: dateToFormat,
		filterOpen,
		filterClose,
		filterDaysHigh,
		filterDaysLow,
		filterVolume
	}
	
	Object.entries(dataObj).forEach( (key, value) => {
		$w('#'+key[0]).text = key[1];
		$w('#'+key[0]).expand();
	});
}

export function filterMonth_change(event, $w) {
	filtersChange();
}

export function filterDay_change(event, $w) {
	filtersChange();
}

export function filterYear_change(event, $w) {
	filtersChange();
}